import { render, staticRenderFns } from "./InvoiceRuleForm.vue?vue&type=template&id=b3650b72&scoped=true"
import script from "./InvoiceRuleForm.vue?vue&type=script&lang=js"
export * from "./InvoiceRuleForm.vue?vue&type=script&lang=js"
import style0 from "./InvoiceRuleForm.vue?vue&type=style&index=0&id=b3650b72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3650b72",
  null
  
)

export default component.exports